import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';

// Knowledge brain admin (A1c). Admin-only; reachable by URL today. Sidebar nav entry +
// feature-flag gating are a deliberate follow-up (app-shell wiring).
export const routes = [
  {
    path: frontendURL('accounts/:accountId/knowledge'),
    name: 'knowledge_sources_index',
    component: Index,
    meta: {
      permissions: ['administrator'],
    },
  },
];
